import { Component, EventEmitter, Output } from '@angular/core';
import { AppMainComponent } from './../app.main.component';
import { CoreService } from '../core/_services/core.services';
import { CONSTANTES_SESION } from '../core/_util/services-util';
import { SafeResourceUrl } from './app.safeResourceUrl.pipe';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    username: String = sessionStorage.getItem('username');
    nombre: string = sessionStorage.getItem(CONSTANTES_SESION.NOMBRE);
    nombreAMostrar: String = '';
    url: any;
    tieneFoto: Boolean = false;
    countNotificaciones: any;

    @Output() dialogoContrasena = new EventEmitter<any>();
    @Output() dialogoSesion = new EventEmitter<any>();

    constructor(
        public app: AppMainComponent,
        public coreService: CoreService
    ) { }

    ngOnInit(): void {
        //this.getNotificaciones();
        // this.revisadoNotificacion();
        if (this.nombre !== null && this.nombre !== undefined && this.nombre !== '') {
            this.nombreAMostrar = this.nombre.split(' ')[0];
        }
        this.coreService.get('/datos-basicos').subscribe(
            (res: any[]) => {
                if (res['foto'] != null && res['foto'] != undefined && res['foto'] != null) {
                    this.coreService.download('/ver-foto').subscribe(
                        (res: any) => {
                            let blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                            let file = new File([blob], "foto_perfil", { type: res.headers.get('Content-Type'), lastModified: Date.now() });
                            this.url = URL.createObjectURL(file);
                            this.tieneFoto = true;
                        },
                        (err: any) => {
                            console.log(err);
                        }
                    )
                } else {
                    this.tieneFoto = false;
                }
            },
            (err: any) => {
                console.log(err);
            }
        )
    }

    abrirLink(url) {
        window.open(url, '_blank')
    }

    getNotificaciones() {
        this.coreService.get('/notificaciones').subscribe(
            (res: any[]) => {
                this.countNotificaciones = res;
            },
            (err: any) => {
                console.log(err);
            }
        )
    }

    revisadoNotificacion() {

        this.coreService.put('/revisado','').subscribe(
            (res: any[]) => {
                this.countNotificaciones = res;
                this.getNotificaciones();
            },
        )
    }

}

    // getCountNotificaciones(){
    //     this.countNotificaciones.length

    // }
